export default {
      id: "arrow-usage",
      viewBox: "0 0 33 24",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#arrow",
      toString: function () {
        return this.url;
      }
    }